export function SubmitShortcutInfo() {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
  const specialKeyText = isMac ? "⌘" : "Ctrl"

  return (
    <span
      style={{
        opacity: '0.4',
      }}
    >
      <i>
        (Press {specialKeyText} + Enter to Submit)
      </i>
    </span>
  )
}